import { ApiBlueprint, discoveryApiRef, fetchApiRef, PageBlueprint } from '@backstage/frontend-plugin-api';
import { techRadarApiRef } from '@internal/backstage-plugin-techradar-exxcellent';
import { TechRadarClient } from './TechRadarClient';

export const techRadarPage = PageBlueprint.make({
    name: 'tech-radar',
    params: {
        path: '/tech-radar',
        loader: async () => {
            const { customTechRadarPage } = await import('./CustomTechRadarPage');
            return customTechRadarPage;
        },
    },
});

export const techRadarApi = ApiBlueprint.make({
  name: 'tech-radar',
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechRadarClient(discoveryApi, fetchApi),
    }),
});